<script>
  // The application bar.
  //
  // Was a floating rounded `navbar w-3/4 mx-auto` island with the title centred
  // and the action crammed against the right edge. Centring the title is what
  // forced `navbar-start` to exist as a spacer holding an empty <p>.
  //
  // Sticky now: the Solved list runs long enough that the header used to be
  // several screens up.
  //
  // The 3px rail is the whole of this app's visual identity. Its colour is
  // --s, which is the one token the BGO Tool and the Dev Tool deliberately
  // disagree on.
  export let title;
  /** Small tag next to the title. The Dev Tool uses it for "DEV". */
  export let badge = null;
  export let href = "/";
</script>

<header
  class="sticky top-0 z-30 border-b border-base-300 bg-base-100/85 backdrop-blur"
>
  <div class="h-[3px] bg-secondary"></div>

  <div class="mx-auto flex h-14 max-w-6xl items-center gap-3 px-4">
    <a {href} class="flex min-w-0 items-center gap-2.5 hover:opacity-80">
      <img
        src="/RIC-Icon.png"
        alt="RIC"
        class="h-7 w-7 rounded object-contain"
      />
      <span class="truncate text-base font-semibold tracking-tight">
        {title}
      </span>
      {#if badge}
        <span
          class="rounded-badge bg-secondary/10 px-1.5 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wider text-secondary"
        >
          {badge}
        </span>
      {/if}
    </a>

    <div class="ml-auto flex items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</header>
